export const TICKETS_TABLENAME = process.env.TICKETS_TABLENAME;
export const TICKETS_COUNT_ID_VALUE = "TICKETS_COUNT";
export const TICKETS_GITHUB_USER_NAME_INDEX = "githubUserNameIndex";

export const TICKET_META_DESCRIPTION = `
Join me at React Day Bangalore (@ReactDayIn) on Jun 8-9, 2022. 

Grab your free ticket now.

`;

export const TOTP_OPTIONS = {
  step: 1 * 60,
  window: 10,
};

export const PANEL_SLUGS = [
  "web-performance",
  "react-native",
  "finding-your-first-job",
];
